<template>
  <div>
    <b-form @submit.prevent="onSubmit">
      <!-- Hours inputs only for COUNTER method -->
      <b-row v-if="methodType === 'COUNTER'" class="mb-3">
        <b-col md="6">
          <label class="text-muted">Due Running Hours</label>
          <InputCurrency
            prepend=""
            v-model.number="postpone.possible_maintenance_hours"
            placeholder="input hours"
            class="w-100"
            disabled
            append="Hours"
          />
        </b-col>
        <b-col md="6">
          <label class="text-muted">Extra Hours</label>
          <InputCurrency
            prepend=""
            append="Hours"
            class="w-100"
            v-model.number="postpone.extra_hours"
            placeholder="input hours"
          />
        </b-col>
      </b-row>

      <b-row v-else>
        <!-- Due Date (readonly) -->
        <b-col md="6">
          <b-form-group label="Due Date" label-for="due-date">
            <b-form-input
              id="due-date"
              v-model="dueDateLocal"
              class="w-100"
              disabled
              type="date"
            />
          </b-form-group>
        </b-col>

        <!-- Postponed Date (required) -->
        <b-col md="6">
          <b-form-group label="Postponed Date *" label-for="postponed-date">
            <b-form-input
              id="postponed-date"
              class="w-100"
              type="date"
              v-model="postpone.extra_date"
              required
            />
          </b-form-group>
        </b-col>
      </b-row>

      <!-- Attachments (UI only; not included in payload per schema) -->
      <!-- <b-form-group label="Postponed Attachment">
        <b-form-file
          multiple
          :state="true"
          @change="onFilesSelected"
          browse-text="Browse"
          placeholder="Pilih file..."
          drop-placeholder="Drop files here..."
          :key="files.length"
        />
        <div class="mt-2">
          <b-badge
            v-for="(f, idx) in files"
            :key="`file-${idx}`"
            variant="warning"
            pill
            class="mr-2 mb-2 align-middle"
          >
            {{ f.name }}
            <b-button
              size="xs"
              variant="link"
              class="p-0 ml-1"
              @click="removeFile(idx)"
              >×</b-button
            >
          </b-badge>
        </div>
        <small class="text-muted d-block mt-1">
          File Type: .pdf .xls .xlsx .doc .docx .jpg .jpeg .png | Max File Size:
          2 MB
        </small>
      </b-form-group> -->

      <!-- Reason -->
      <b-form-group label="Reason Postponed">
        <b-form-textarea
          v-model="postpone.reason"
          rows="5"
          placeholder="Tulis alasan penundaan..."
        />
      </b-form-group>

      <div class="d-flex align-items-center justify-content-between mt-3">
        <div></div>
        <div class="ml-auto d-flex">
          <b-button
            variant="outline-secondary"
            class="mr-2"
            :disabled="loading"
            @click="$emit('close')"
          >
            Cancel & Close
          </b-button>
          <b-button type="submit" variant="primary" :disabled="loading">
            <b-spinner small class="mr-2" v-if="loading" />
            Submit
          </b-button>
        </div>
      </div>
    </b-form>
  </div>
</template>

<script>
import InputCurrency from '@/src/components/global/InputCurrency.vue'
import { pmsActions } from '@/src/Utils/helper'

export default {
  name: 'FormMaintenancePostpone',
  components: { InputCurrency },
  props: {
    selectedData: {
      type: Object,
      default: null,
    },
    methodType: {
      type: String,
      default: 'COUNTER', // or 'COUNTER'
    },
  },
  data() {
    return {
      loading: false,
      dueDateLocal: this.selectedData?.possible_maintenance_date,
      files: [],
      postpone: {
        extra_hours: 0,
        extra_date: null,
        possible_maintenance_hours:
          this.selectedData.possible_maintenance_hours,
        reason: '',
      },
    }
  },
  watch: {
    'selectedData.possible_maintenance_date'(val) {
      this.dueDateLocal = val
    },
  },
  methods: {
    ...pmsActions,
    onFilesSelected(e) {
      const list = Array.from(e.target.files || [])
      this.files = list.filter((f) => f.size <= 2 * 1024 * 1024)
    },
    removeFile(i) {
      this.files.splice(i, 1)
    },
    async buildPayload() {
      return {
        action: 'postpone',
        postpone: {
          extra_hours: this.postpone.extra_hours,
          extra_date: this.postpone.extra_date,
          possible_maintenance_hours: this.postpone.possible_maintenance_hours,
          reason: this.postpone.reason,
        },
      }
    },
    async onSubmit() {
      this.loading = true
      try {
        const body = await this.buildPayload()
        const payload = {
          body,
          maintenanceId: this.selectedData?.id,
        }
        const res = await this.actionMaintenance(payload)
        if (res.status == 'success') {
          this.$swal.fire(
            'Success',
            res.data.message || 'Maintenance postponed successfully',
            'success'
          )
          this.$emit('refetch')
          this.$emit('close')
        } else {
          this.$swal.fire(
            'Failed',
            res.data.message || 'Maintenance postponed failed',
            'error'
          )
        }
      } finally {
        this.loading = false
      }
    },
  },
}
</script>

<style scoped>
.badge .btn-link {
  color: inherit;
}
</style>
